<template>

  <div v-if="savelistStore.savelist_page_state.status === 'idle'">
    <TsTypography>{{useTranslation('AccountSaveList-idlePage','Inactief. Pagina is inactief')}}</TsTypography>
  </div>
  <div v-if="savelistStore.savelist_page_state.status === 'loading'">
    <TsLoadingCircularSpinner></TsLoadingCircularSpinner>
  </div>
  <div v-if="savelistStore.savelist_page_state.status === 'failed'">
    <TsTypography>{{useTranslation('AccountSaveList-UnableToRetriveSaveList','Kan uw bewaarlijsten niet ophalen. Probeer het zo nog eens')}}</TsTypography>
  </div>
  <div v-if="savelistStore.savelist_page_state.status === 'success'">
    <TsSaveList></TsSaveList>
  </div>
</template>

<script setup lang="ts">
const TsLoadingCircularSpinner = defineAsyncComponent(() => import('~/components/organisms/TsLoadingCircularSpinner.vue'));
const TsSaveList = defineAsyncComponent(() => import('~/components/organisms/TsSaveList.vue'));

const { isMobile, isDesktop } = useDevice();
const savelistStore = useSavelistStore();

onMounted(async () => {
  // TO-DO: Ping savelist endpoint and check the state and render accordingly
  await savelistStore.verifySaveListHealth();
  // if endpoint is verified, fetch default or mylist
});

definePageMeta({
  layout: "account",
});

// Meta Data
useHead({
  title: 'Opgeslagen kluslijsten',
  meta: [{ name: "description", content: "This is the save list page." }],
});

const save_list_tabs = [
  { label: "All" },
  { label: "Save For Later" },
  { label: "My List" },
  { label: "DIY Dream Tools" },
  { label: "For Home" },
  { label: "New Home WishList" },
];



// Filters Section
const sort_by = ref();
const filter_sort_by_options = ref([{ name: "Date" }, { name: "Order" }]);

const product_listing_layout = ref("grid");

const product_listing_grid_cols = computed(() => {
  if (product_listing_layout.value === "grid" && isDesktop) {
    return 3;
  }

  if (product_listing_layout.value === "grid" && isMobile) {
    return 2;
  }

  if (product_listing_layout.value === "list") {
    return 1;
  }
});

const handleProductListingLayout = (layout: "grid" | "list") => {
  product_listing_layout.value = layout;
};
</script>
